import {SearchAppBar} from "~/apps/core/ui/SearchAppBar";
import {VesselCallList} from "~/apps/packages/vessel-calls/components/VesselCallList/VesselCallList";
import {FiltersBar} from "~/apps/core/ui/FiltersBar";
import {
    VesselCallStatusChipInput,
    VesselCallStatusChipInputProps
} from "~/apps/packages/vessel-calls/components/VesselCallStatusChipInput";
import {DateRangeChipInput, getOptions} from "~/apps/packages/vessel-calls/components/DateRangeChipInput";
import {VesselCallShort} from "~/queries";
import {useHistoryState} from "~/apps/core/utils";
import {useCallback, useEffect, useMemo, useRef, useState} from "react";
import moment from "moment";
import {tuple} from "~/types";
import {DateRangeChipInputProps} from "~/apps/packages/auto-visits/components/DateRangeChipInput";
import {useHistory} from "react-router-dom";
import {AbsoluteContainer} from "~/apps/core/ui/AbsoluteContainer";
import {Box, ToggleButton} from "@mui/material";
import {Star, StarOutlined} from "@mui/icons-material";
import {ToggleChipInput} from "~/apps/core/ui/ChipInput/ToggleChipInput";
import {IconChipInput, IconChipInputProps} from "~/apps/core/ui/ChipInput/IconChipInput";
import {useChangeEffect} from "~/lib/useChangeEffect";


export type FilterState = {
    query?: string
    dateRange?: [Date, Date]
    statuses?: VesselCallShort["status"][]
    favorite?: boolean
}


const useFilterState = () => {
    const [value, setValue, delValue] = useHistoryState<any>({
        name: "filter",
        serialize: state => JSON.stringify(state),
        deserialize: value => JSON.parse(value),
        handleBack: false,
    });

    const filter = useMemo(() => {
        const filter: FilterState = {};
        if (typeof value?.query == "string" && value.query.length > 0) {
            filter.query = value.query;
        }
        if (Array.isArray(value?.statuses) && value.statuses.filter(s => typeof s != "string").length == 0){
            if (value.statuses.length > 0) {
                filter.statuses = value.statuses;
            }
        }
        if (Array.isArray(value?.dateRange) && value.dateRange.length == 2) {
            const dateRange = value.dateRange.map(x => moment(x));
            if (dateRange.filter(x => x.isValid()).length == 2) {
                filter.dateRange = dateRange.map(x => x.toDate());
            }
        }
        if (value?.favorite) {
            filter.favorite = true;
        }

        return filter;
    }, [value]);

    const setFilter = useCallback(async value => {
        if (value) {
            value = {...value};
            if (!value.query) {
                delete value.query;
            }
            if (!value.statuses || value.statuses.length == 0) {
                delete value.statuses;
            }
            if (!value.dateRange){
                delete value.dateRange;
            }
            if (!value.favorite) {
                delete value.favorite;
            }
            if (Object.keys(value).length > 0) {
                setValue(value);
                return;
            }
        }
        await delValue();
    }, []);

    return tuple(filter, setFilter);
}


export const IndexPage = () => {
    const $container = useRef<HTMLDivElement>();
    const history = useHistory();
    const [filter, setFilter] = useFilterState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        /// грязный хак для выставления дефолтного состояния фильтров. Если мы не вернулись назад, то state == true
        if (!history.location.state) {
            history.replace({
                ...history.location,
                state: true,
            });
            setFilter({
                dateRange: getOptions()[0].value
            }).then(() => null);
        }
    }, []);

    useChangeEffect(() => {
        $container.current?.scrollTo(0, 0);
    }, [filter]);

    const handleSearch = (query: string) => {
        setFilter({
            ...filter,
            query: query
        }).then(() => null);
    }

    const handleStatusesChange: VesselCallStatusChipInputProps["onChange"] = (value) => {
        setFilter({
            ...filter,
            statuses: value,
        }).then(() => null);
    }

    const handleDateRangeChange: DateRangeChipInputProps["onChange"] = (value) => {
        setFilter({
            ...filter,
            dateRange: value,
        }).then(() => null);
    }

    const handleFavoriteChange: IconChipInputProps["onChange"] = (value) => {
        setFilter({
            ...filter,
            favorite: value,
        }).then(() => null);
    }

    const handleLoading = (loading) => {
        setLoading(loading);
    }

    return (
        <>
            <SearchAppBar
                position="fixed"
                color="default"
                title="Подход флота"
                onSearch={handleSearch}
                query={filter?.query}
                disabled={loading}
            >
                <FiltersBar>
                    <DateRangeChipInput value={filter?.dateRange} onChange={handleDateRangeChange} disabled={loading}/>
                    <VesselCallStatusChipInput value={filter?.statuses} onChange={handleStatusesChange} disabled={loading}/>
                    <IconChipInput
                        disabled={loading}
                        icon={<StarOutlined/>}
                        selectedIcon={<Star style={{color: "#E8B042"}}/>}
                        value={filter?.favorite}
                        onChange={handleFavoriteChange}
                    />
                </FiltersBar>
            </SearchAppBar>
            <AbsoluteContainer top={104} disableGutters ref={$container}>
                <VesselCallList
                    dateFrom={filter?.dateRange ? filter.dateRange[0] : null}
                    dateTo={filter?.dateRange ? filter.dateRange[1] : null}
                    favorite={filter?.favorite}
                    query={filter?.query}
                    status={filter?.statuses}
                    onLoading={handleLoading}
                />
                <Box minHeight="16px" />
            </AbsoluteContainer>
        </>
    )
}